if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      
      const formData = new FormData(this.form);
      
      // Add UTM parameters from session storage if available
      if (!!document.querySelector(".checkbox_add") && document.querySelector(".checkbox_add").checked){
        let newFormData = new FormData(this.form);
        let newformhtml = document.createElement('form');
        let blankHTML = ``
        for (const pair of newFormData.entries()) {
          if (pair[0] !== 'sections' || pair[0] !== 'sections_url') {
          }
          blankHTML += `<input type="hidden" name="items[0][${pair[0]}]" value="${pair[1]}">`
        }
        blankHTML += `
        <input type="hidden" name="items[1][quantity]" value="1">
        <input type="hidden" name="items[1][id]" value="${add_product_metafield}">
        `

        newformhtml.innerHTML = `
        ${blankHTML}
        `
        let tempFormData = new FormData(newformhtml)
          if (this.dataset.cartType != 'page') {
            tempFormData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            tempFormData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
        config.body = tempFormData

      }else{
        if (this.dataset.cartType != 'page') {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          
        }
        config.body = formData;
      }

      //debugger
      
      // handle restricted items
      const restrictedProductIds = [
        6865460756579, 6588060532835, 6588073574499, 7060640497763,
        6588056830051, 6839153950819, 6627470409827, 6588076261475,
        6630265159779, 6588068986979, 6588939206755, 7060646494307,
        6748097904739, 6839160012899, 6683962441827, 7060634173539,
        6588055617635
      ];

      const restrictedZones = ["SA", "AE", "QA", "OM", "KW", "IL", "BH"];


      const addedProductId = this.form.querySelector('[data-productid]').dataset.productid
      //debugger
      const hasRestrictedProducts = restrictedProductIds.includes(Number(addedProductId));

      if (hasRestrictedProducts) {
        let userLocation = Shopify.country;
        if (userLocation && restrictedZones.includes(userLocation)) {
            // alert("Restricted item is not allowed")
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.submitButton.style.display = 'none'
            return this.handleErrorMessage("This item cannot be shipped to your location")
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;


          // A/B Testing
          if (window.location && window.location.pathname.indexOf('/products/delay-spray') !== -1) {
            window.pagesense = window.pagesense || [];
            window.pagesense.push(['trackEvent', 'pdp-buy-now']);
          }

          
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (document.querySelector('.quick-add-carousel')) {
            // close the quick add carousel modal
            closeModal()
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
